/* TÖSTI: navy -> brun #2f231b, sand -> #F7F2E3, grå -> sand. Cookie-banner (shadow DOM), Klaviyo-popups og prøv-på-widget. Tilføjet fil. */
(function () {
  var BROWN = 'rgb(47, 35, 27)';
  var SAND = 'rgb(247, 242, 227)';
  function parse(v) {
    var m = v && v.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
    if (!m) return null;
    return { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] };
  }
  function kind(v) {
    var c = parse(v);
    if (!c || c.a < 0.05) return null;
    if (c.b > c.r + 15 && c.b >= c.g - 5 && c.b < 200 && c.r < 120) return 'brown';
    if (c.r === 75 && c.g === 61 && c.b === 42) return 'brown';
    if (c.r >= 228 && c.g >= 215 && c.b >= 165 && c.r - c.b >= 24 && c.r - c.b <= 100) return 'sand';
    return null;
  }
  function paint(e, prop, v) {
    var k = kind(v);
    if (k) e.style.setProperty(prop, k === 'brown' ? BROWN : SAND, 'important');
  }
  function fixEl(e) {
    try {
      var c = getComputedStyle(e);
      paint(e, 'background-color', c.backgroundColor);
      paint(e, 'color', c.color);
      ['Top', 'Right', 'Bottom', 'Left'].forEach(function (s) {
        if (c['border' + s + 'Width'] !== '0px') paint(e, 'border-' + s.toLowerCase() + '-color', c['border' + s + 'Color']);
      });
    } catch (x) {}
  }
  function fixTree(root) {
    if (root.nodeType === 1) fixEl(root);
    var l = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < l.length; i++) fixEl(l[i]);
  }
  function greyToSand() {
    var l = document.querySelectorAll('section, div, article');
    for (var i = 0; i < l.length; i++) {
      var e = l[i];
      var c = parse(getComputedStyle(e).backgroundColor);
      if (!c || c.a < 0.9) continue;
      if (c.r >= 236 && c.r <= 250 && Math.abs(c.r - c.g) < 4 && Math.abs(c.g - c.b) < 4) {
        var r = e.getBoundingClientRect();
        if (r.width > 300 && r.height > 100) e.style.setProperty('background-color', SAND, 'important');
      }
    }
  }
  var watched = new WeakSet();
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 120);
  }
  function watch(node) {
    if (watched.has(node)) return;
    watched.add(node);
    new MutationObserver(schedule).observe(node, { childList: true, subtree: true });
  }
  function scan() {
    var hosts = document.querySelectorAll('csm-cookie-consent');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) {
        fixTree(hosts[i].shadowRoot);
        watch(hosts[i].shadowRoot);
      }
    }
    var kl = document.querySelectorAll('.needsclick, [class*="klaviyo"], [id*="klaviyo"], [class*="utry"]');
    for (var j = 0; j < kl.length; j++) {
      fixTree(kl[j]);
      watch(kl[j]);
    }
  }
  function updSwipers() {
    var c = document.querySelectorAll('.swiper-container');
    for (var i = 0; i < c.length; i++) {
      if (c[i].swiper && c[i].swiper.update) c[i].swiper.update();
    }
  }
  function start() {
    scan();
    greyToSand();
    watch(document.body);
    var n = 0;
    var iv = setInterval(function () {
      scan();
      if (n === 2 || n === 6) greyToSand();
      if (++n > 12) clearInterval(iv);
    }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', function () {
    updSwipers();
    setTimeout(updSwipers, 800);
    greyToSand();
  });
})();
